import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { CookieStorage } from 'aws-amplify/utils';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
    },
  },
});

// Auf symbolbuch.de liegen die Tokens als Cookie für die ganze Domain, damit
// Subdomain-Apps (kochen.symbolbuch.de) dieselbe Anmeldung nutzen können.
// Lokal (localhost) bleibt es beim Standard-localStorage.
const host = window.location.hostname;
if (host === 'symbolbuch.de' || host.endsWith('.symbolbuch.de')) {
  cognitoUserPoolsTokenProvider.setKeyValueStorage(
    new CookieStorage({ domain: '.symbolbuch.de', path: '/', secure: true, sameSite: 'lax', expires: 30 }),
  );
  // Alte Tokens aus dem localStorage (vor der Cookie-Umstellung) entfernen
  try {
    Object.keys(localStorage)
      .filter((k) => k.startsWith('CognitoIdentityServiceProvider.'))
      .forEach((k) => localStorage.removeItem(k));
  } catch { /* localStorage may be unavailable */ }
}
